export default class PromiseKeeper {
	constructor() {
		this.pools = Object.create(null)
	}

	_preparePool(pool) {
		this.pools[pool] || (this.pools[pool] = Object.create(null))
	}

	set (id, value, pool = 'default') {
		if (value == null) return

		this._preparePool(pool)

		this.pools[pool][id] = {
			value,
			refs: 1
		}
	}

	get (id, pool = 'default') {
		this._preparePool(pool)

		let rec = this.pools[pool][id]
		if (!rec || rec.value == null) return

		rec.refs++
		this.pools[pool][id] = rec

		return rec.value
	}

	unset (id, pool = 'default') {
		this._preparePool(pool)

		let rec = this.pools[pool][id]
		if (!rec || rec.value == null) return

		rec.refs--

		if(rec.refs === 0) {
			delete this.pools[pool][id]
		} else {
			this.pools[pool][id] = rec
		}
	}

	has (id, pool = 'default') {
		this._preparePool(pool)

		return !!this.pools[pool][id]
	}

	ids (pool = 'default') {
		this._preparePool(pool)

		return Object.keys(this.pools[pool])
	}

	refs (id, pool = 'default') {
		this._preparePool(pool)

		return this.has(id, pool) ? this.pools[pool][id].refs : undefined
	}
}


// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/utils/promise-keeper.js